@if (showNav()) {
  <!-- Nav click keeps menu open when interacting inside; keyboard users navigate via the links/buttons within -->
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <nav class="sidenav" [class.open]="menuOpen()" #menu (click)="menuOpen.set(true)">
    <div class="top">
      <div class="close-container">
        <button
          type="button"
          class="close"
          (click)="menuOpen.set(false); $event.stopPropagation()"
          [class.hidden]="!menuOpen()"
          aria-label="Close menu"
        >
          <app-icon name="cross" colour="white" />
        </button>
      </div>
      @if (user(); as user) {
        <div class="my-profile-container">
          <a
            [class.active]="isProfileActive()"
            class="avatar-container"
            [routerLink]="['/guardians', user.id, 'profile']"
            (click)="navigateToProfile($event)"
            aria-label="View my profile"
          >
            <app-avatar [avatar]="user" />
            <div class="info">
              <span>{{ userName() | formatName }}</span>
              <span class="my-profile-label"> My Profile </span>
            </div>
          </a>
        </div>
      }
      <ul>
        @for (item of menuItems(); track item.link) {
          <li>
            <a
              [routerLink]="item.link"
              [class.active]="item.isActive"
              (click)="menuOpen.set(false); $event.stopPropagation()"
            >
              @if (item.label === 'Communication' && unreadCount() > 0) {
                <app-icon [name]="item.icon ?? ''" matBadge="{{ unreadCount() }}" matBadgeOverlap="false" />
              } @else {
                <app-icon
                  [name]="item.icon ?? ''"
                  [colour]="item.icon !== 'my-hub' && item.icon !== 'email-inactive' ? 'white' : undefined"
                />
              }
              <span>{{ item.label }}</span>
            </a>
          </li>
        }
        <li>
          <button type="button" [class.active]="isToggleMenuActive()" (click)="toggleMenu(); $event.stopPropagation()">
            <app-icon name="hamburger" />
            <span>Menu</span>
          </button>
        </li>
      </ul>
      <div class="submenu" [class.show]="menuOpen()">
        <ul>
          @for (item of submenuItems(); track item.link) {
            <li>
              <a
                [routerLink]="item.link"
                [class.active]="item.isActive"
                (click)="menuOpen.set(false); $event.stopPropagation()"
              >
                <span>{{ item.label }}</span>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
    <div class="version-container">
      <p>Version {{ currentApplicationVersion }}</p>
    </div>
    <div class="bottom">
      <a routerLink="settings" routerLinkActive="active" (click)="menuOpen.set(false); $event.stopPropagation()">
        <app-icon name="cog" />
        <span>Settings</span>
      </a>
      <button type="button" (click)="logout(); $event.stopPropagation()">
        <app-icon name="logout" />
        <span>Logout</span>
      </button>
    </div>
  </nav>
}
